enum ExploreAvailability {
  All = "All",
  Available = "Available",
  Sold = "Sold",
}

export default ExploreAvailability;
